// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rhBE","toggle":"styles_toggle__vCi84","preview":"styles_preview__xKmJO"};